// extracted by mini-css-extract-plugin
export default {"SearchBarWithSuggestions":"SearchBarWithSuggestions__SearchBarWithSuggestions-rNaf5"};